"use client";

import { useEffect, useState } from "react";

export function SuccessBloom({
  word = "Boa!",
  durationMs = 2600,
  onDone,
}: {
  word?: string;
  durationMs?: number;
  onDone?: () => void;
}) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setVisible(false);
      onDone?.();
    }, durationMs);
    return () => window.clearTimeout(timer);
  }, [durationMs, onDone]);

  if (!visible) return null;

  return (
    <div className="success-bloom-overlay" aria-hidden="true">
      <span className="success-bloom-word">{word}</span>
    </div>
  );
}
